import useModal from 'lib/hooks/useModal';
import { COMPLETED_TRANSACTION_STATUSES } from 'lib/constants/transaction/completedTransactionStatuses';

import ReceiptModal from 'components/shared/Receipt/ReceiptModal';

const useViewReceipt = ({ data }) => {
  const { isOpen, openModal, closeModal } = useModal();

  const isCompleted = COMPLETED_TRANSACTION_STATUSES.includes(data?.status?.toLowerCase());

  const option = isCompleted
    ? { label: 'View receipt', icon: 'eye-mono', onClick: openModal }
    : null;

  const modal = <ReceiptModal transactionId={data?.id} isOpen={isOpen} onClose={closeModal} />;

  return [option, modal];
};

export default useViewReceipt;
